
import React, {FC} from 'react';
import {NavProps} from 'components/Header';
import {handleClick} from 'components/Header/MenuNav/Group/Link/Link';
import {Routes} from 'constants/index';
import {useRedirectURL} from 'utils/redirects';

import Lines from './svgs/lines.inline.svg';
import User from './svgs/user.inline.svg';

import * as styles from './styles.module.scss';

export const Browse: FC<NavProps> = ({nav}) => (
	<div className={styles.link} onClick={(e) => {
		nav.flip();
		e.stopPropagation();
	}}>
		Browse <Lines />
	</div>
);

export const YourAccount: FC<NavProps> = ({nav}) => (
	<div className={styles.link} onClick={(e) => {
		nav.flip();
		e.stopPropagation();
	}}>
		Your account <User />
	</div>
);

export const SignIn: FC<NavProps> = ({nav}) => {
	const redirect = useRedirectURL(Routes.signIn);
	const onClick = (e: React.MouseEvent) => {
		const handler = handleClick(nav, redirect);
		handler(e);
	};
	return (
		<div className={styles.link} onClick={onClick}>
			Sign in <User />
		</div>
	);
};
